import React, { useState, useEffect, useContext } from "react";
import { MapView } from "@aws-amplify/ui-react";
import { Marker } from "react-map-gl";
import '@aws-amplify/ui-react/styles.css';
import { useAddress } from "../../hooks/useAddress";
import Floading from "../../components/Floading/Floading";
import { AuthContext } from "../../context/AuthContext";
import "./style/CreateAddressScreen.css";
import { size } from "lodash";
import { useNavigate } from "react-router-dom";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import { useCreateAddressScreen } from "./hooks/useCreateAddressScreen";
import Switch from "react-switch";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import {
  HomeOutline,
  EllipsisHorizontalCircle,
  BriefcaseOutline,
  LocationOutline,
  SearchOutline
} from "react-ionicons";
import FInputText from "../../components/Finputs/FInputText/FInputText";
import VectorIcons from "../../components/VectorIcons/VectorIcons";
import FContainer from "../../components/FContainer/FContainer";


const CreateAddressScreen = ({ param }) => {
  const { directions, searchDirection } = useCreateAddressScreen();
  const { createAddress, addresses, getAddresses } = useAddress();
  const route = useNavigate();
  const { loading, setAlert } = useContext(AuthContext);
  const [{ longitude, latitude }, setMarkerLocation] = useState({
    longitude: -75.63912,
    latitude: 6.279584,
  });
  const [placeName, setPlaceName] = useState("");
  const [data, setData] = useState([]);

  useEffect(() => {
    getAddresses();
  }, []);

  useEffect(() => {
    searchDirection(placeName, longitude, latitude);
  }, [placeName]);

  const [disabledconfirmAddress, SetDisabledconfirmAddress] = useState(true);
  const MySwal = withReactContent(Swal);
  let [hiddenDirection, setHiddenDirection] = useState(false);
  const [internalNumber, setInternalNumber] = useState("");

  return (
    <>
      <Floading open={loading}></Floading>
      <FContainer>
        <div className="border-0 w-full">
          <div className="w-full">
            <div className="flex justify-end items-center relative">
              <input
                type="text"
                value={placeName == " " ? "" : placeName}
                onChange={(e) => {
                  setHiddenDirection(false)
                  SetDisabledconfirmAddress(true)
                  setPlaceName(!e.target.value ? " " : e.target.value);
                }}
                placeholder="Buscar dirección"
                className="border-0 rounded-md px-2 py-2 pr-[42px] w-full shadow-Box mb-2"
              />
              <div
                className="absolute bg-white px-2 py-2 mb-2 rounded-xl border-0"
              >
                <SearchOutline />
              </div>
            </div>
            {directions.length > 0 ? (
              <div className={`grid grid-cols-1 gap-1 rounded-md border-0 shadow-Box py-1 bg-white ${hiddenDirection ? "hidden" : ""}`}>
                {directions.map((direction, index) => {
                  return (
                    <div className={`col-span-1 grid grid-cols-12 px-5 py-[5px] hover:bg-gray-100 ${index == 0 ? "bg-gray-100" : ""}`}
                      onClick={() => {
                        setHiddenDirection(true)
                        SetDisabledconfirmAddress(false)
                        setMarkerLocation({
                          longitude: direction.Place.Geometry.Point[0],
                          latitude: direction.Place.Geometry.Point[1],
                        });
                        setPlaceName(direction.Place.Label);
                        setData({
                          distance: direction.Distance,
                          typeOfAddressId: "HOME",
                          isPrincipal: true,
                          place: {
                            addressNumber: size(direction.Place.AddressNumber) > 0
                              ? direction.Place.AddressNumber
                              : null,
                            country: direction.Place.Country,
                            geometry: {
                              point: direction.Place.Geometry.Point,
                            },
                            interpolated: direction.Place.Interpolated,
                            label: direction.Place.Label,
                            municipality:
                              size(direction.Place.Municipality) > 0
                                ? direction.Place.Municipality
                                : null,
                            neighborhood:
                              size(direction.Place.Neighborhood) > 0
                                ? direction.Place.Neighborhood
                                : null,
                            postalCode: direction.Place.PostalCode,
                            region: direction.Place.Region,
                            street:
                              size(direction.Place.Street) > 0
                                ? direction.Place.Street
                                : null,
                            subRegion: direction.Place.SubRegion,
                          },
                        });
                      }}  >
                      <div className="border-0 col-span-1 grid items-center ">
                        <LocationOutline
                          height="17px"
                          width="17px"
                        />
                      </div>
                      <div className="border-0 col-span-11 text-[3vw] sm:text-[15px]" key={index}>
                        <p className="">{direction.Place.Label}</p>
                      </div>
                    </div>

                  );
                })}
              </div>) : null
            }
            <div className={`${!hiddenDirection ? "hidden" : ""} pt-4`}>
              <div className={`font-bold text-[4.5vw] xxs:text-[14px]`}>
                Apartamento / Unidad
              </div>
              <input
                type="text"
                value={internalNumber}
                onChange={(e) => {
                  setInternalNumber(e.target.value)
                }}
                maxLength={20}
                placeholder="Ej: 201-B"
                className="border-0 rounded-md px-2 py-2 pr-[42px] w-full shadow-Box mb-2"
              />
            </div>
          </div>
        </div>
        <Fbutton
          value="Confirmar dirección"
          disabled={disabledconfirmAddress}
          onClick={() => {
            data.place.internalNumber = internalNumber
            MySwal.fire({
              showCloseButton: true,
              showCancelButton: false,
              showConfirmButton: false,
              html: <MySwalSalveDirection addresses={addresses} createAddress={createAddress} route={route} data={data} />,
            });
          }}
        />
      </FContainer>
    </>
  );
};


const MySwalSalveDirection = ({ addresses, createAddress, route, data }) => {
  const MySwal = withReactContent(Swal);

  const [principal, setPrincipal] = useState(false);
  const [typeOfAddressId, setTypeOfAddressId] = useState("HOME");
  const [tag, setTag] = useState(null);

  useEffect(() => {
    setPrincipal(addresses.length > 0 ? false : true);
  }, [addresses]);

  const nextScreen = async (data) => {
    if ((await createAddress(data)) === true) {
      const next = () => {
        route(-1);
      };
      Swal.fire({
        showCloseButton: true,
        title: 'Éxito',
        text: "La dirección ha sido guardada exitosamente",
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        // iconColor: "#fd6e0d",
        confirmButtonText: 'Entendido'
      }).then((result) => {
        if (result.isConfirmed) {
          next();
        } else {
          route(-1);
        }
      })
    } else {
      Swal.fire({
        showCloseButton: true,
        title: 'Advertencia',
        text: "No se pudo crear tu dirección",
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        iconColor: "#fd6e0d",
        confirmButtonText: 'Entendido'
      })
    }
  };

  return (
    <>
      <div className="border-0 w-full font-bold mt-5 text-[5vw] xxs:text-[17px]">
        <Switch
          onColor="#F10C8F"
          onChange={() => {
            if (!addresses.length > 0 ? false : true) {
              setPrincipal(!principal);
            }
          }}
          checked={principal}
        />
        {" Marcar como dirección principal"}
      </div>
      <div className="border-0 cursor-pointer w-full grid grid-cols-3 place-items-center mt-5">
        <div
          className={`col-span-1 border-2 rounded-xl ${typeOfAddressId == "HOME" ? "shadow-Box" : ""
            }`}
          onClick={() => {
            setTag(null)
            setTypeOfAddressId("HOME");
          }}
        >
          <div className="border-0 grid grid-cols-1 p-2">
            <div className="border-0 w-full col-span-1 grid place-items-center">
              <div className="w-[6vw] h-[6vw] xxs:w-[21px] xxs:h-[21px]">
                <HomeOutline
                  cssClasses={"!w-full !h-full"}
                  color={typeOfAddressId == "HOME" ? "#F10C8F" : "#A0A0A0"}
                />
              </div>
            </div>
            <div
              className={`border-0 col-span-1 text-[4.5vw] xxs:text-[14px] grid place-items-center ${typeOfAddressId == "HOME"
                ? "font-bold text-Secondary"
                : "text-[#A0A0A0]"
                }`}
            >
              Casa
            </div>
          </div>
        </div>
        <div
          className={`col-span-1 border-2 rounded-xl ${typeOfAddressId == "WORK" ? "shadow-Box" : ""
            }`}
          onClick={() => {
            setTag(null)
            setTypeOfAddressId("WORK");
          }}
        >
          <div className="border-0 grid grid-cols-1 p-2">
            <div className="border-0 w-full col-span-1 grid place-items-center">
              <div className="w-[6vw] h-[6vw] xxs:w-[21px] xxs:h-[21px]">
                <BriefcaseOutline
                  cssClasses={"!w-full !h-full"}
                  color={typeOfAddressId == "WORK" ? "#F10C8F" : "#A0A0A0"}
                />
              </div>
            </div>
            <div
              className={`border-0 col-span-1 text-[4vw] xxs:text-[14px] grid place-items-center ${typeOfAddressId == "WORK"
                ? "font-bold text-Secondary"
                : "text-[#A0A0A0]"
                }`}
            >
              Trabajo
            </div>
          </div>
        </div>
        <div
          className={`col-span-1 border-2 rounded-xl ${typeOfAddressId == "OTHER" ? "shadow-Box" : ""
            }`}
          onClick={() => {
            setTag(null)
            setTypeOfAddressId("OTHER");
          }}
        >
          <div className="border-0 grid grid-cols-1 p-2">
          <div className="border-0 w-full col-span-1 grid place-items-center">
              <div className="w-[6vw] h-[6vw] xxs:w-[21px] xxs:h-[21px]">
                <EllipsisHorizontalCircle
                  cssClasses={"!w-full !h-full"}
                  color={typeOfAddressId == "OTHER" ? "#F10C8F" : "#A0A0A0"}
                />
              </div>
            </div>
            <div
              className={`border-0 col-span-1 text-[4.5vw] xxs:text-[14px] grid place-items-center ${typeOfAddressId == "OTHER"
                ? "font-bold text-Secondary"
                : "text-[#A0A0A0]"
                }`}
            >
              Otro
            </div>
          </div>
          <div>
          </div>
        </div>
      </div>
      {
        typeOfAddressId == "OTHER" ? (
          <div className="text-left">
            <FInputText
              title="Descripción"
              placeholder="Ej: Casa de mis padres"
              onChange={(value) => {
                setTag(value == "" ? null : value)
              }}
            /></div>) : null
      }

      <Fbutton
        value="Guardar"
        onClick={() => {
          data.isPrincipal = principal;
          data.typeOfAddressId = typeOfAddressId;
          data.tag = tag;
          nextScreen(data);
        }}
        disabled={size(data) > 0 ? false : true}
      />
    </>
  );
};


export default CreateAddressScreen;
